import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './styles.css';
import AppLayout from './AppLayout';
import { LanguageProvider } from './language/LanguageContext';
import Home from './pages/Home';
import PrivacySecurity from './pages/PrivacySecurity';
import TermsConditions from './pages/TermsConditions';
import Support from './pages/Support';
import DeleteAccount from './pages/DeleteAccount';
import DeleteAccountRequest from './pages/DeleteAccountRequest';
import NotFound from './pages/NotFound';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <NotFound />,
    children: [
      { index: true, element: <Home /> },
      { path: 'privacy-security', element: <PrivacySecurity /> },
      { path: 'terms-conditions', element: <TermsConditions /> },
      { path: 'support', element: <Support /> },
      { path: 'delete-account', element: <DeleteAccount /> },
      { path: 'delete-account/request', element: <DeleteAccountRequest /> },
      { path: '*', element: <NotFound /> }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <RouterProvider router={router} />
    </LanguageProvider>
  </React.StrictMode>
);
